import React from "react";

const AssetCategory = () => {
  return (
    <div className="container mt-4">
      <h4>Assets Category</h4>

      <div className="card p-3">
        <table className="table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {[1,2,3].map(i => (
              <tr key={i}>
                <td>Dell Laptop</td>
                <td><span className="badge bg-success">Active</span></td>
                <td>✏️ 🗑</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AssetCategory;